import { PaginationResponse } from '@repo/ui/data-table'

import { EnrollmentAction } from '../../lib/types/models/enrollment-actions/enrollment-action'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getEnrollmentActions(id: number): Promise<PaginationResponse<EnrollmentAction>> {
  return restApiClient
    .url(constructApiUrl(API.enrollments.getEnrollmentActions.url, { id }))
    .get<PaginationResponse<EnrollmentAction>>()
}
